import Headroom from 'headroom.js'

export const headroomTolerance = {
  small: {
    up: 5,
    down: 600,
  },
  lap: {
    up: 5,
    down: 5,
  }
}

const head = document.getElementById('head')

let headroom = {}

if (head && typeof head.classList !== 'undefined' && typeof head.classList.add !== 'undefined') {
  headroom = new Headroom(head, {
    offset: 74,
    tolerance: headroomTolerance.lap
  })
  headroom.init()
}

export default headroom



// WEBPACK FOOTER //
// ./sportspower/assets/es6/init-headroom.js